let searchTimeout;

let limitedList = 1;

export function initPriceWatchDogModal()
{
    $('#cancel-watchdog').click(processCancelWatchdog);

    $('#priceWatchDogModal').on('shown.bs.modal', function(e)
    {
        // zobrazíme spinner
        $('#priceWatchDogModal .modal-body .spinner').show();

        // skryjeme form-body
        $('#priceWatchDogModal .form-body').hide();

        // hlášku o ok chceme mít skrytou
        $('#priceWatchDogModal .form-ok').hide();

        // URL, na kterou pošleme request pro zobrazení formu, máme v data atributu divu obalující form.
        const url = new URL($(this).data('form-url'));
        url.searchParams.set('timestamp', (Date.now()).toString());

        // ajax
        $.ajax({
            url: url,
            type: 'get',

            success: function(response)
            {
                // vypneme spinner
                $('#priceWatchDogModal .modal-body .spinner').hide();

                // přidáme do body html
                $('#priceWatchDogModal .form-body').html(response);

                // zobrazíme form-body
                $('#priceWatchDogModal .form-body').show();


                // vyhledávač produktu
                $('#priceWatchDogModal input[name="productName"]').keyup(searchProducts);

                // mazání vyhledaných produktů
                $('#priceWatchDogModal #clear-search-result').click(clearSearchResult);

                $('#priceWatchDogModal #expand-productlist').click(expandSearchList);

                initSubmitForm();
                initLinks();

                // Magie - selectpickery se pravděpodobně naloadují 2x
                $('.update-product-store').selectpicker('destroy');
            }
        });
    });

    // pokud máme hash, rovnou zobrazíme
    if ($('#priceWatchDogModal').data('is-filled') === 1)
    {
        $('#priceWatchDogModal').modal('show');
    }
}

const initSubmitForm = () => {
    // submit formu
    $(".priceWatchDogModal").submit(function(e) {

        e.preventDefault();

        var form = $(this);
        var url = form.attr('action');
        var formData = new FormData(this);

        // zobrazíme spinner
        $('#priceWatchDogModal .modal-body .spinner').show();

        // skryjeme form-body
        $('#priceWatchDogModal .form-body').hide();

        $.ajax({
            type: "POST",
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            cache: false,
            url: url,
            data: formData, // serializování elementu
            success: function(response, status, xhr)
            {
                // vypneme spinner
                $('#priceWatchDogModal .modal-body .spinner').hide();

                let data = response;
                const contentType = xhr.getResponseHeader('Content-Type');

                // pokud mi přijde json, tak se form odeslal
                if (contentType.indexOf('json') > -1) {

                    // zobrazíme hlášku
                    $('#priceWatchDogModal .form-ok').show();
                }
                // pokud přišel html, tak se něco ve formu nepovedlo
                else
                {
                    // zobrazíme form-body
                    $('#priceWatchDogModal .form-body').show();

                    $('#priceWatchDogModal .form-body').html(data);

                    initSubmitForm();
                    searchProducts(true);
                    initLinks();
                }
            }
        });
    });
}

function expandSearchList()
{
    let input = document.querySelector('#priceWatchDogModal input[name="productName"]');
    let elem = document.querySelector('#priceWatchDogModal #expand-productlist');
    let productAddedIds = JSON.parse(document.querySelector('#priceWatchDogModal input[name="productAddedIds"]').value);
    let spinner = document.getElementById('product-spinner');

    // pokud je query prázné, nepošleme ajax
    if (elem.dataset.query.length === 0)
    {
        return;
    }

    limitedList = 0;

    $.nette.ajax({
        url: input.dataset.link,
        data: {
            'query': elem.dataset.query,
            'productAddedIds': productAddedIds,
            'limited': limitedList,
        },
        start: function () {
            spinner.style.display = "block";
        },
        complete: function () {
            spinner.style.display = "none";
            initAddLinks(
                'pwg-add-to-productlist',
                'productAddedIds',
                'pwg-chosen-products',
                'pwg-remove-product',
                'pwg-remove-init',
                searchProducts);
            initRemoveLinks(
                'pwg-remove-product',
                'pwg-remove-init',
                'productAddedIds',
                searchProducts)
        }
    });
}

function searchProducts(useTimeout = true)
{
    let input = document.querySelector('#priceWatchDogModal input[name="productName"]');
    let productAddedIds = JSON.parse(document.querySelector('#priceWatchDogModal input[name="productAddedIds"]').value);
    let spinner = document.getElementById('product-spinner');

    // pokud je query prázné, nepošleme ajax
    if (input.value.length === 0)
    {
        return;
    }

    limitedList = 1;

    // request pošleme až po 1 sekundě, kdy nechodí znaky z inputu
    clearTimeout(searchTimeout);

    let currentTimeout = 1;
    if (useTimeout)
    {
        currentTimeout = 1000;
    }

    searchTimeout = setTimeout(function() {
        $.nette.ajax({
            url: input.dataset.link,
            data: {
                'query': input.value,
                'productAddedIds': productAddedIds,
                'limited': limitedList,
            },
            start: function () {
                spinner.style.display = "block";
            },
            complete: function () {
                spinner.style.display = "none";
                initExpandListLink();
                initAddLinks(
                    'pwg-add-to-productlist',
                    'pwg-chosen-products',
                    'pwg-remove-product');
                initRemoveLinks('pwg-remove-product');
                initSelectChange();
            }
        });
    }, currentTimeout);
}

function initLinks()
{
    initAddLinks(
        'pwg-add-to-productlist',
        'pwg-chosen-products',
        'pwg-remove-product');

    initSelectChange();

    initRemoveLinks('pwg-remove-product');
}

function initExpandListLink()
{
    var expandLink = document.getElementById('expand-productlist');

    if (expandLink !== null)
    {
        expandLink.addEventListener('click', function (e){
            e.preventDefault();
            expandSearchList();
        });
    }
}

function addProduct(productId, url)
{
    let spinner = document.getElementById('product-spinner');
    let searchInput = document.querySelector('#priceWatchDogModal input[name="productName"]');
    $.nette.ajax({
        url: url,
        data: {
            'productId': productId,
            'query': searchInput.value,
            'limited': limitedList,
        },
        start: function () {
            spinner.style.display = "block";
        },
        complete: function () {
            spinner.style.display = "none";
            initAddLinks(
                'pwg-add-to-productlist',
                'pwg-chosen-products',
                'pwg-remove-product');
            initRemoveLinks('pwg-remove-product');
            initSelectChange();
            initExpandListLink();
        }
    });
}

function changeProductStore(productId, storeId, url)
{
    $.nette.ajax({
        url: url,
        data: {
            'productId': productId,
            'storeId': storeId,
            'limited': limitedList,
        },
        complete: function () {
            initAddLinks(
                'pwg-add-to-productlist',
                'pwg-chosen-products',
                'pwg-remove-product');
            initRemoveLinks('pwg-remove-product');
            initSelectChange();
        }
    });
}

function initRemoveLinks(removeClass)
{
    let spinner = document.getElementById('product-spinner');
    let searchInput = document.querySelector('#priceWatchDogModal input[name="productName"]');
    [...document.querySelectorAll('.' + removeClass)].forEach(function(item) {
        item.addEventListener('click', function (e)
        {
            e.preventDefault();

            $.nette.ajax({
                url: this.dataset.url,
                data: {
                    'productId': this.dataset.productId,
                    'query': searchInput.value,
                    'limited': limitedList,
                },
                start: function () {
                    spinner.style.display = "block";
                },
                complete: function () {
                    spinner.style.display = "none";
                    initAddLinks(
                        'pwg-add-to-productlist',
                        'pwg-chosen-products',
                        'pwg-remove-product');
                    initRemoveLinks('pwg-remove-product');
                    initSelectChange();
                }
            });
        });
    });
}

function initAddLinks(addClass, tableId, removeClass)
{
    [...document.querySelectorAll('.' + addClass)].forEach(function(item) {
        item.addEventListener('click', function (e)
        {
            e.preventDefault();
            addProduct(this.dataset.storeId, this.dataset.link)

            // ale stejně odebereme...
            this.closest('tr').remove();

            initRemoveLinks(removeClass);
        });
    });
}

function initSelectChange()
{
    [...document.querySelectorAll('.update-product-store')].forEach(function(item) {
        item.addEventListener('change', function (e)
        {
            e.preventDefault();
            changeProductStore(this.dataset.productId, this.value, this.dataset.link)
        });
    });
}

function processCancelWatchdog()
{
    var url = $('input[name=cancel]').data('url');
    var email = $('input[name=email]').val();
    var hash = $('input[name=hash]').val();

    if (email.length < 1)
    {
        alert("Vyplňte email pro zrušení odběru");
    }

    if (hash.length < 1)
    {
        alert("Zrušit odběr lze pouze přes odkaz v emailu");
    }

    $.nette.ajax({
        url: url,
        data: {
            'email': email,
            'watchdoghash': hash
        },
        start: function () {
            spinner.style.display = "block";
        },
        complete: function () {
            spinner.style.display = "none";
            initAddLinks(
                'pwg-add-to-productlist',
                'pwg-chosen-products',
                'pwg-remove-product');
            initRemoveLinks('pwg-remove-product');
            initSelectChange();
        }
    });

    return false;
}

function clearSearchResult(){
    $('#priceWatchDogModal input[name="productName"]').val('');
    $('.pricewatchdog-result-table').remove();
}